import * as React from "react";

import "./alert-error-dialog-2.scss";

import {cs}            from "@Common/react/chain-services";
import {ModalService3} from "@Common/ui-components/modal-service-3/modal-service-3";

export const AlertErrorDialog2 = ({next: rootNext}) => cs(
    ["modal", ({}, next) => ModalService3<any>({
        width: 500,
        xdQaName: "Alert Error Dialog",
        next,
        rootNext,
    })],
    ({modal}) => (
        <div className="alert-error-dialog-2-432">
            <div className="header">
                <i className="fa fa-exclamation-triangle"/>
                <div className="title" xd-qa-type="label" xd-qa-name="Warning">
                    Warning!
                </div>
            </div>
            <div className="content">
                {modal.params.messages.map((m,i) => (
                    <div
                        className="message" xd-qa-type="text" xd-qa-name="Message"
                        key={i}
                    >
                        {m}
                    </div>
                ))}
            </div>
            <div className="footer">
                <button {...{
                    "xd-qa-type": "button",
                    "xd-qa-name": "Alert OK",
                    className: "next",
                    onClick: () => modal.close(),
                }}>
                    OK
                </button>
            </div>
        </div>
    ),
);
